import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

export default function MetricCard({ title, value, icon: Icon, accent = 'navy', subtitle, testId }) {
  const accentMap = {
    navy: 'from-slate-800 to-slate-900 text-white',
    rose: 'from-rose-500 to-rose-600 text-white',
    emerald: 'from-emerald-500 to-emerald-600 text-white',
    amber: 'from-amber-500 to-amber-600 text-white',
    violet: 'from-violet-600 to-violet-700 text-white',
    sky: 'from-sky-500 to-sky-600 text-white',
  };
  return (
    <Card data-testid={testId} className="border border-slate-200 shadow-sm hover:shadow-md transition-shadow">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-slate-600">{title}</CardTitle>
        {Icon && (
          <div className={cn('rounded-lg bg-gradient-to-br p-2', accentMap[accent] || accentMap.navy)}>
            <Icon className="h-4 w-4" />
          </div>
        )}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold text-slate-900">{value}</div>
        {subtitle && <p className="text-xs text-slate-500 mt-1">{subtitle}</p>}
      </CardContent>
    </Card>
  );
}
